import React from 'react';
import { ModalHeader } from '../components/molecules/ModalHeader';
import { ModalBody } from '../components/molecules/ModalBody';
import { ModalFooter } from '../components/molecules/ModalFooter';

export const findModalHeader = (children: React.ReactNode): boolean => {
  return findMComponentInModal({ children, component: ModalHeader, componentName: 'Modal.Header' });
};

export const findModalBody = (children: React.ReactNode): boolean => {
  return findMComponentInModal({ children, component: ModalBody, componentName: 'Modal.Body' });
};

export const findModalFooter = (children: React.ReactNode): boolean => {
  return findMComponentInModal({ children, component: ModalFooter, componentName: 'Modal.Footer' });
};

export const findMComponentInModal = ({
  children,
  component,
  componentName,
}: {
  children: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: React.ComponentType<any>;
  componentName: string;
}): boolean => {
  return React.Children.toArray(children).some((child) => {
    if (!React.isValidElement(child)) return false;

    // Check if this child is a ModalHeader
    if (child.type === component) return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const childType = child.type as React.ComponentType<any> & {
      displayName?: string;
      name?: string;
    };
    if (childType.displayName === componentName) return true;
    if (childType.name === componentName) return true;

    // If it's a Fragment or has children, search recursively
    if (child.type === React.Fragment || child.props.children) {
      return findMComponentInModal({ children: child.props.children, component, componentName });
    }

    return false;
  });
};
